import { render, staticRenderFns } from "./EmpresaList.vue?vue&type=template&id=31eec34e"
import script from "./EmpresaList.vue?vue&type=script&lang=js"
export * from "./EmpresaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports